export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

const filterRoutesByRole = (routes: INavigationRoute[], role: string): INavigationRoute[] => {
  return routes
    .filter((route) => {
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true
      }
      if (!route.meta.allowedRoles) {
        return true
      }
      return false
    })
    .map((route) => {
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/dashboard',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Monthly Dashboard',
      meta: {
        icon: 'dashboard',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    {
      name: 'performance',
      displayName: 'Driver Performance Dashboard',
      meta: {
        icon: 'analytics',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    {
      name: 'scorecard',
      displayName: 'Scorecard',
      meta: {
        icon: 'assessment',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    {
      name: 'ev-dashboard',
      displayName: 'EV Dashboard',
      meta: {
        icon: 'electric_car',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    {
      name: 'reports',
      displayName: 'Financial Reports',
      meta: {
        icon: 'assessment',
        allowedRoles: ['finance', 'finance-staff'],
      },
      children: [
        {
          name: 'reports',
          displayName: 'All Reports',
          meta: {
            icon: 'assessment',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
      ],
    },
    {
      name: 'drivers',
      displayName: 'Driver Finance',
      meta: {
        icon: 'moped',
        allowedRoles: ['finance', 'finance-staff'],
      },
      children: [
        {
          name: 'drivers',
          displayName: 'Driver Management',
          meta: {
            icon: 'moped',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'trips',
          displayName: 'Trip Management',
          meta: {
            icon: 'route',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
      ],
    },
    {
      name: 'financial-upload',
      displayName: 'Upload Financial Sheet',
      meta: {
        icon: 'upload_file',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: {
        icon: 'manage_accounts',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
  ],
}

export default sidebarRoutes
